module.exports = {
          srcSet: __webpack_public_path__ + "f0c572f3154a43199ffc611b8dd062eb-16.png"+" 16w",
          images:[ {path: __webpack_public_path__ + "f0c572f3154a43199ffc611b8dd062eb-16.png",width: 16,height: 18}],
          src: __webpack_public_path__ + "f0c572f3154a43199ffc611b8dd062eb-16.png",
          toString:function(){return __webpack_public_path__ + "f0c572f3154a43199ffc611b8dd062eb-16.png"},
          
          width: 16,
          height: 18
        }